import { constants } from "./module";
import { filter } from "./filter";
export function filtersBlock() {
    const $body = constants.body;
    const $window = $(window);
    const $point = 1024;
    let $is_mobile = false;
    const $filtersBlock = $(".filters-block");
    const $filtersHolder = $filtersBlock.find(".filters-holder");
    const $filters = $filtersBlock.find(".checkbox-list-block");
    const $showFiltersBtn = $filtersBlock.find(".show-filters-button");
    const $closeFiltersBtn = $filtersBlock.find(".close-filters-button");


    init();
    function init() {
        $filters.each(function () {
            filter($(this));
        });
        isMobile();
        setEvents();
    }
    function isMobile() {
        $is_mobile = ($window.innerWidth() <= $point) ? true : false;
    }
    function setEvents() {
        $window.on("resize", function () {
            isMobile();
            if (!$is_mobile && $filtersHolder.hasClass("active")) {
                hideFilters();
            }
        });
        $showFiltersBtn.on("click", function () {
            showFilters();
        });
        $filtersHolder.on("click", function (e) {
            if (this !== e.target) return;
            hideFilters();
        });
        $closeFiltersBtn.on("click", function () {
            hideFilters();
        });
    }
    function hideFilters() {
        $body.removeAttr("style");
        $filtersHolder.removeClass("active");
    }
    function showFilters() {
        $body.css("overflow", "hidden");
        $filtersHolder.addClass("active");
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/filtersBlock.js